import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Dropdown } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  StatusFormatter,
  formLabelsTheme,
  formatDate,
  getValueOptions,
  iconError,
  showDeleteDialog,
  showErrorDialog,
  showSuccessDialog,
  sizePerPageList,
  statusInboundFormatter,
  useStyles,
  useStylesReddit,
  columnsExportExcel
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  sortCaret,
  toAbsoluteUrl,
  headerSortingClasses,
} from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { ThemeProvider } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  fetchParameter,
  fetchParameter2,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";
import { FormHelperText } from "@material-ui/core";

import { selectPagination } from "../../modules/Auth";
import {
  editBooking,
  editBookingConfirm,
  fetchIdBooking,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  selectIdBooking,
  fetchBookingParty,
  selectBookingParty,
  selectPageNoParty,
  selectPageSizeParty,
  selectTotalRecordParty,
  removeBookingParty,
  fetchBookingVehicle,
  selectBookingVehicle,
  removeBookingVehicle,
  editBookingAmmend,
  fetchGenerateExcel
} from "./bookingSlice";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";

import { Autocomplete } from "@material-ui/lab";
import { ModalCreateVehicle } from "./ModalCreateVehicle";
import { ModalCreateParty } from "./ModalCreateParty";
import { fetchCountryAll } from "../location/locationSlice";
import { BookingCancel } from "./BookingCancel";
import { ModalEditVehicle } from "./ModalEditVehicle";
import { VehicleUploadView } from "./VehicleUploadView";
import { VehicleUpload } from "./VehicleUpload";
import { ModalPartyRadio } from "./ModalPartyRadio";
import { fetchParty } from "../party/partySlice";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const BookingEdit = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectIdBooking);
  const dataParty = useSelector(selectBookingParty);
  const dataVehicle = useSelector(selectBookingVehicle);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const pageNoParty = useSelector(selectPageNoParty);
  const pageSizeParty = useSelector(selectPageSizeParty);
  const totalRecordParty = useSelector(selectTotalRecordParty);
  const dataDelivery = useSelector(selectParameter);
  const { id } = useParams();
  const paginationSet = useSelector(selectPagination);

  const [vehiclesFilter, setVehiclesFilter] = useState("");
  const [vehiclesFilterValue, setVehiclesFilterValue] = useState("");
  const [row, setRow] = useState(null);
  const [getData, setGetData] = useState(false);
  const [color, setColor] = useState("white");

  //
  const [formValues, setFormValues] = useState({
    client: {
      value: "",
      error: false,
      required: "Y",
    },
    client_name: {
      value: "",
      error: false,
      required: "Y",
    },
    booking_date: {
      value: "",
      error: false,
      required: "Y",
    },
    request_shipping_date: {
      value: "",
      error: false,
      required: "N",
    },
    request_arrival_date: {
      value: "",
      error: false,
      required: "N",
    },
    consignee: {
      value: "",
      error: false,
      required: "N",
    },
    consignee_name: {
      value: "",
      error: false,
      required: "N",
    },
    delivery_arrangement: {
      value: "",
      error: false,
      required: "N",
    },

    port_of_discharge: {
      value: "",
      error: false,
      required: "N",
    },
    port_of_discharge_name: {
      value: "",
      error: false,
      required: "N",
    },
    port_of_loading: {
      value: "",
      error: false,
      required: "N",
    },

    port_of_loading_name: {
      value: "",
      error: false,
      required: "N",
    },
    remarks: {
      value: "",
      error: false,
      required: "N",
    },
    order_no: {
      value: "",
      error: false,
      required: "N",
    },
  });

  // formVehicle
  const [formVehicle, setFormVehicle] = useState({
    party_id: {
      value: "",
      error: false,
      required: "N",
    },
    party_name: {
      value: "",
      error: false,
      required: "N",
    },
  });

  // party

  // formVehicle
  const [formParty, setFormParty] = useState({
    party_id: {
      value: "",
      error: false,
      required: "Y",
    },
    party_type: {
      value: "",
      error: false,
      required: "Y",
    },
    party: {
      value: "",
      error: false,
      required: "Y",
    },
    party_name: {
      value: "",
      error: false,
      required: "",
    },
    address1: {
      value: "",
      error: false,
      required: "N",
    },
    address2: {
      value: "",
      error: false,
      required: "N",
    },
    city: {
      value: "",
      error: false,
      required: "N",
    },
    zip_code: {
      value: "",
      error: false,
      required: "N",
    },
    province: {
      value: "",
      error: false,
      required: "N",
    },
    country_id: {
      value: "",
      error: false,
      required: "Y",
    },
  });

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load

      await dispatch(fetchIdBooking(id));

      await dispatch(
        fetchParameter({
          paramgroup_code: "DELIVERY_ARRANGEMENT",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter2({
          paramgroup_code: "ALL_PARTY",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchCountryAll({
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParty({
          party_setting: "CONSIGNEE",
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId !== null) {
      setFormValues({
        client: {
          value: dataId.client,
          error: false,
          required: "Y",
        },
        client_name: {
          value: dataId.client_name,
          error: false,
          required: "Y",
        },
        booking_date: {
          value:
            dataId.booking_date === null
              ? null
              : moment(dataId.booking_date).format("YYYY-MM-DD"),
          error: false,
          required: "Y",
        },
        request_shipping_date: {
          value:
            dataId.request_shipping_date === null
              ? null
              : moment(dataId.request_shipping_date).format("YYYY-MM-DD"),
          error: false,
          required: "N",
        },
        request_arrival_date: {
          value:
            dataId.request_arrival_date === null
              ? null
              : moment(dataId.request_arrival_date).format("YYYY-MM-DD"),
          error: false,
          required: "N",
        },
        consignee: {
          value: dataId.consignee === null ? "" : dataId.consignee,
          error: false,
          required: "N",
        },
        consignee_name: {
          value: dataId.consignee_name === null ? "" : dataId.consignee_name,
          error: false,
          required: "N",
        },
        delivery_arrangement: {
          value: dataId.delivery_arrangement,
          error: false,
          required: "N",
        },

        port_of_discharge: {
          value:
            dataId.port_of_discharge === null ? "" : dataId.port_of_discharge,
          error: false,
          required: "N",
        },
        port_of_discharge_name: {
          value:
            dataId.port_of_discharge_name === null
              ? ""
              : dataId.port_of_discharge_name,
          error: false,
          required: "N",
        },
        port_of_loading: {
          value: dataId.port_of_loading === null ? "" : dataId.port_of_loading,
          error: false,
          required: "N",
        },

        port_of_loading_name: {
          value:
            dataId.port_of_loading_name === null
              ? ""
              : dataId.port_of_loading_name,
          error: false,
          required: "N",
        },
        remarks: {
          value: dataId.remarks,
          error: false,
          required: "N",
        },
        order_no: {
          value: dataId.order_no,
          error: false,
          required: "N",
        },
      });
      dispatch(
        fetchBookingParty({
          booking_id: id,
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
      dispatch(
        fetchBookingVehicle({
          booking_id: id,
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
    }
  }, [dataId]);

  useEffect(() => {
    // Add number
    const pageBefore = pageSize * (pageNo - 1);
    const initData =
      dataVehicle === null
        ? []
        : dataVehicle.map((item, index) => {
            return {
              ...item,
              no: index + 1 + pageBefore,
            };
          });
    setTableDataVehicle(initData);
  }, [dataVehicle, pageSize, pageNo]);
  const [tableDataVehicle, setTableDataVehicle] = useState(dataVehicle);

  useEffect(() => {
    // Add number
    const pageBefore = pageSize * (pageNo - 1);
    const initData =
      dataParty === null
        ? []
        : dataParty.map((item, index) => {
            return {
              ...item,
              no: index + 1 + pageBefore,
            };
          });
    setTableDataParty(initData);
  }, [dataParty, pageSizeParty, pageNoParty]);
  const [tableDataParty, setTableDataParty] = useState(dataParty);

  // HanldeSave

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);

    console.log(isValid, "isValid");
    return isValid;
  };

  const handleSave = async () => {
    if (!validatePost()) {
      return;
    }

    const params = {
      booking_id: id,
      client: formValues.client.value,
      consignee: formValues.consignee.value,
      booking_date: formValues.booking_date.value,
      request_shipping_date: formValues.request_shipping_date.value,
      delivery_arrangement: formValues.delivery_arrangement.value,
      request_arrival_date: formValues.request_arrival_date.value,
      port_of_loading: formValues.port_of_loading.value,
      port_of_discharge: formValues.port_of_discharge.value,
      remarks: formValues.remarks.value,
      order_no: formValues.order_no.value,
    };

    try {
      const response = await dispatch(editBooking(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const [showShipper, setShowShipper] = useState(false);

  const [fields, setFields] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  const vehiclesOptions = [
    {
      value: "vin",
      label: "VIN",
    },
    {
      value: "von",
      label: "VON",
    },
    {
      value: "master_code",
      label: "Master Code ",
    },
    {
      value: "model_code",
      label: "Model Code ",
    },
    {
      value: "color_code",
      label: "Color Code ",
    },
  ];

  const handleChangeVehicles = (e) => {
    if (e === null) {
      e = undefined;
      setVehiclesFilter("");
    } else {
      setVehiclesFilter(e.value);
    }
  };

  const handleSearch = async () => {
    let params = {};

    params[vehiclesFilter] = vehiclesFilterValue;
    params.booking_id = id;
    params.pageNo = 1;
    params.pageSize = paginationSet;

    try {
      const response = await dispatch(fetchBookingVehicle(params));
      if (response.payload.data.status === 200) {
        window.scrollTo(0, 850);
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      let params = {};

      params[vehiclesFilter] = vehiclesFilterValue;
      params.booking_id = id;
      params.pageNo = page;
      params.pageSize = sizePerPage;
      try {
        const response = await dispatch(fetchBookingVehicle(params));
        if (response.payload.data.status === 200) {
          window.scrollTo(0, 850);
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.slice().sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.slice().sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
      setTableDataVehicle(result);
    }
  };

  const handleTableChangeParty = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      let params = {};

      params.booking_id = id;
      params.pageNo = page;
      params.pageSize = sizePerPage;
      try {
        const response = await dispatch(fetchBookingVehicle(params));
        if (response.payload.data.status === 200) {
          window.scrollTo(0, 850);
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.slice().sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.slice().sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
      setTableDataParty(result);
    }
  };

  const options = {
    page: pageNo,
    sizePerPage: pageSize,
    showTotal: true,
    totalSize: totalRecord,
    sizePerPageList: sizePerPageList,
  };

  const optionsParty = {
    page: pageNoParty,
    sizePerPage: pageSizeParty,
    showTotal: true,
    totalSize: totalRecordParty,
    sizePerPageList: sizePerPageList,
  };

  const handleDelete = async (e, row) => {
    const params = { bookingvehicle_id: `${row.bookingvehicle_id}` };
    const action = await showDeleteDialog(`Are you sure you want to delete?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(removeBookingVehicle({ data: params }));
        if (response.payload.data.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await dispatch(fetchIdBooking(id));
          await dispatch(
            fetchBookingVehicle({
              booking_id: id,
              pageNo: 1,
              pageSize: paginationSet,
            })
          );
          await window.scrollTo(0, 850);
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleDeleteParty = async (e, row) => {
    const params = { bookingparty_id: `${row.bookingparty_id}` };
    const action = await showDeleteDialog(`Are you sure you want to delete?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(removeBookingParty({ data: params }));
        if (response.payload.data.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await dispatch(
            fetchBookingParty({
              booking_id: id,
              pageNo: 1,
              pageSize: paginationSet,
            })
          );

          await window.scrollTo(0, 850);
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const actionFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div>
          <OverlayTrigger
            overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}
          >
            <div
              className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
              onClick={(e) => {
                setRow(row);
                setGetData(true);
                setShowVehicleEdit(true);
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-light">
                {dataId.booking_status === "6010" ? (
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")} />
                ) : (
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/Search.svg")} />
                )}
              </span>
            </div>
          </OverlayTrigger>

          {dataId.booking_status === "6010" && (
            <OverlayTrigger
              overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
            >
              <div
                className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                onClick={(e) => handleDelete(e, row)}
              >
                <span className="svg-icon svg-icon-md svg-icon-light">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")} />
                </span>
              </div>
            </OverlayTrigger>
          )}
        </div>
      </>
    );
  };

  const columns = [
    {
      text: "VIN",
      dataField: "vin",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "VON",
      dataField: "von",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Master Code",
      dataField: "master_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Model Code",
      dataField: "model_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Model Name",
      dataField: "model_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Color Code",
      dataField: "color_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Color Name",
      dataField: "color_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Require Acc. Installation",
      dataField: "inbound_rule",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: StatusFormatter,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Dealer Code",
      dataField: "dealer_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Dealer Name",
      dataField: "dealer_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatter,
      align: "center",
      headerAlign: "center",
      style: { minWidth: "150px" },
    },
  ];

  const actionFormatterParty = (e, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div>
          <OverlayTrigger
            overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}
          >
            <div
              className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
              onClick={(e) => {
                console.log(row, "row click");
                setRow(row);
                setShowParty(true);
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-light">
                {dataId.booking_status === "6010" ? (
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")} />
                ) : (
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/Search.svg")} />
                )}
              </span>
            </div>
          </OverlayTrigger>
          {dataId.booking_status === "6010" && (
            <OverlayTrigger
              overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
            >
              <div
                className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                onClick={(e) =>
                  handleDeleteParty(e, row)
                }
              >
                <span className="svg-icon svg-icon-md svg-icon-light">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")} />
                </span>
              </div>
            </OverlayTrigger>
          )}
        </div>
      </>
    );
  };

  const columnsParty = [
    {
      text: "Party Type",
      dataField: "party_type",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Code",
      dataField: "party",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },

    {
      text: "Name",
      dataField: "party_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Address",
      dataField: "address1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },

    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatterParty,
      align: "center",
      headerAlign: "center",
      style: { minWidth: "150px" },
    },
  ];

  // modal Create vehicle
  const [showVehicle, setShowVehicle] = useState(false);
  const [showVehicleEdit, setShowVehicleEdit] = useState(false);
  const [showUpload, setShowUpload] = useState(false);

  const [fileName, setFileName] = useState("Upload Template File");
  const [file, setFile] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const [showCancel, setShowCancel] = useState(false);

  const handleConfirm = async () => {
    const params = {
      booking_id: id,
    };
    try {
      const response = await dispatch(editBookingConfirm(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleAmend = async () => {
    const params = {
      booking_id: id,
    };
    try {
      const response = await dispatch(editBookingAmmend(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleDownloadUploadProgress = async (row) => {
    if (row == null || row.data == null || !(row.data instanceof Array) || row.data.length <= 0) {
      return;
    }

    const headers = Object.keys(row.data[0]);
    const shownIndexes = headers.map((h, i) => columnsExportExcel.find((c) => c.dataField === h) != null ? i : null).filter(x => x != null);

    const payload = {
      FileName: `Upload Result ${row.file_name}`,
      SheetName: 'Booking Vehicle',
      Data: [
        headers.filter((v, i) => shownIndexes.includes(i)).map((h) => columnsExportExcel.find((c) => c.dataField === h)?.text || h)
      ],
      ConditionalIndex: headers.filter((v, i) => shownIndexes.includes(i)).findIndex((h) => h === 'status_validate'),
      misc_header_id : row.misc_header_id,
      index_select : shownIndexes
    };
    // for (let i = 0; i < row.data.length; i++) {
    //   const rowData = Object.keys(row.data[i]).map((key) => {
    //     return row.data[i][key] || '';
    //   });
    //   payload.Data.push(rowData.filter((v, i) => shownIndexes.includes(i)));
    // }

    try {
      const response = await dispatch(fetchGenerateExcel(payload));
      
      if (response.payload.status === 200) {
        const blob = new Blob([response.payload.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `Upload Result ${row.file_name}.xlsx`;
        link.click();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      console.log("catch");
      showErrorDialog(error.message);
    }
  };

  // handle UPload File
  const [showUploadView, setShowUploadView] = useState(false);
  const [rowUpload, setRowUpload] = useState(null);
  const [rowUploadStatus, setRowUploadStatus] = useState(null);

  const actionFileFormatter = (e, row, rowIndex) => {
    return (
      <div className="d-flex flex-nowrap">
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">View</Tooltip>}
        >
          <a
            className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mb-1"
            onClick={() => {
              setRowUploadStatus(row.status);
              setRowUpload(row);
              setShowUploadView(true);
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/Search.svg")} />
            </span>
          </a>
        </OverlayTrigger>
        {
          row.status === 'Completed' && (
            <OverlayTrigger
              overlay={<Tooltip id="vehicle-download-tooltip">Download</Tooltip>}
            >
              <a
                className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mb-1"
                onClick={() => handleDownloadUploadProgress(row)}
              >
                <span className="svg-icon svg-icon-md svg-icon-light">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/Download.svg")} />
                </span>
              </a>
            </OverlayTrigger>
          )
        }
      </div>
    );
  };
  const columnsFile = [
    {
      text: "Uploaded File",
      dataField: "file_name",
    },
    {
      text: "Status",
      dataField: "status",
    },
    {
      text: "Action",
      dataField: "Action",
      formatter: actionFileFormatter,
    },
  ];

  // modal party
  const [showParty, setShowParty] = useState(false);
  const [getParty, setGetParty] = useState(false);

  const deliveryOptions = dataDelivery.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const indexDelivery = deliveryOptions.findIndex(
    (obj) => obj.value === formValues.delivery_arrangement.value
  );

  const handleChangeDelivery = (e, params) => {
    const value = params.value;
    setFormValues({
      ...formValues,
      ["delivery_arrangement"]: {
        ...formValues["delivery_arrangement"],
        value,
      },
    });
  };

  const [selectedVehicle, setSelectedVehicle] = useState([]);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      {dataId && (
        <>
          <Card>
            <CardBody>
              <div className="d-flex justify-content-between">
                <p className=" font-size-h3 text-title-primary font-weight-boldest">
                  Booking : {dataId.booking_no}
                </p>
                {/* <Button className="my-btn-primary-dark d-flex justify-content-end">
                  Create Area
                </Button> */}
              </div>

              {/* Header */}

              <div
                className="m-2 d-flex bg-primary-dark align-items-center"
                style={{ borderRadius: "10px" }}
              >
                <div className="m-2 flex-fill font-weight-boldest text-center  text-white">
                  Booking Date :{formatDate(dataId.booking_date)}
                </div>
                <div className="m-2 flex-fill font-weight-boldest text-center text-white">
                  Client : {dataId.client_name}
                </div>
                <div className="m-2 flex-fill font-weight-boldest text-center text-white">
                  Consignee : {dataId.consignee_name}
                </div>
                <div className="m-2 flex-fill font-weight-boldest text-center text-white ">
                  Status : {statusInboundFormatter(dataId.booking_status_name)}
                </div>
                <div className="m-2 flex-fill font-weight-boldest text-center text-white">
                  <Dropdown>
                    <Dropdown.Toggle className="primary" id="dropdown-basic">
                      Action
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {dataId.booking_status === "6010" && (
                        <>
                          <Dropdown.Item onClick={handleConfirm}>
                            Confirm
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={(e) => {
                              setShowCancel(true);
                            }}
                          >
                            Cancel
                          </Dropdown.Item>
                        </>
                      )}

                      {dataId.booking_status !== "6010" &&
                        dataId.is_amend === "Y" && (
                          <Dropdown.Item onClick={handleAmend}>
                            Amend
                          </Dropdown.Item>
                        )}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>

              <ThemeProvider theme={formLabelsTheme}>
                <>
                  {/* Basic Detail */}
                  <div className="ml-2 mt-5">
                    <p className="font-weight-boldest">Basic Detail</p>
                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <RedditTextField
                              required
                              label="Booking Date"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              type="date"
                              size="small"
                              fullWidth
                              name="booking_date"
                              value={formValues.booking_date.value}
                              onChange={handleChange}
                              error={formValues.booking_date.error}
                              helperText={
                                formValues.booking_date.error ? (
                                  <FormHelperText
                                    sx={{ mt: "5px", mb: "-10px" }}
                                  >
                                    {iconError} {"This field is required"}
                                  </FormHelperText>
                                ) : (
                                  ""
                                )
                              }
                              disabled={
                                dataId.booking_status !== "6010" ? true : false
                              }
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <RedditTextField
                              label="Request Shipping Date"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              fullWidth
                              size="small"
                              type="date"
                              name="request_shipping_date"
                              value={formValues.request_shipping_date.value}
                              onChange={handleChange}
                              disabled={
                                dataId.booking_status !== "6010" ? true : false
                              }
                            />
                          </Col>
                        </Row>

                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <RedditTextField
                              label="Order No"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              fullWidth
                              size="small"
                              type="text"
                              name="order_no"
                              value={formValues.order_no.value}
                              onChange={handleChange}
                              disabled={
                                dataId.booking_status !== "6010" ? true : false
                              }
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <RedditTextField
                              label="Consignee"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              value={formValues.consignee_name.value}
                              readOnly
                            />
                          </Col>
                          {dataId.booking_status === "6010" && (
                            <>
                              <Col xs={1} sm={1} md={1} lg={1}>
                                <div>
                                  <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                                    <span
                                      className="svg-icon svg-icon-md svg-icon-light"
                                      onClick={() => {
                                        setShowShipper(true);
                                      }}
                                    >
                                      <SVG
                                        src={toAbsoluteUrl(
                                          "/media/svg/icons/New/Search.svg"
                                        )}
                                      />
                                    </span>
                                  </a>
                                </div>
                              </Col>
                              {formValues.consignee_name.value !== "" && (
                                <Col xs={1} sm={1} md={1} lg={1}>
                                  <div
                                    style={{
                                      marginTop: "22px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setFormValues({
                                        ...formValues,
                                        ["consignee"]: {
                                          ...formValues["consignee"],
                                          value: "",
                                        },
                                        ["consignee_name"]: {
                                          ...formValues["consignee_name"],
                                          value: "",
                                        },
                                      });
                                    }}
                                  >
                                    <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                                      <SVG
                                        src={toAbsoluteUrl(
                                          "/media/svg/icons/New/x-square.svg"
                                        )}
                                      />
                                    </span>
                                  </div>
                                </Col>
                              )}
                            </>
                          )}
                        </Row>
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <RedditTextField
                              label="Request Arrival Date"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              fullWidth
                              size="small"
                              type="date"
                              name="request_arrival_date"
                              value={formValues.request_arrival_date.value}
                              onChange={handleChange}
                              disabled={
                                dataId.booking_status !== "6010" ? true : false
                              }
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <Autocomplete
                              disablePortal
                              label="Delivery Arrangement"
                              name="Delivery Arrangement"
                              options={deliveryOptions}
                              getOptionLabel={(option) => option.label}
                              getOptionValue={(option) => option.value}
                              value={
                                deliveryOptions.find(
                                  (option) =>
                                    option.value ===
                                    formValues.delivery_arrangement.value
                                ) || null
                              }
                              onChange={(event, newValue) => {
                                if (newValue === null) {
                                  setFormValues({
                                    ...formValues,
                                    ["delivery_arrangement"]: {
                                      ...formValues["delivery_arrangement"],
                                      value: "",
                                    },
                                  });
                                } else {
                                  setFormValues({
                                    ...formValues,
                                    ["delivery_arrangement"]: {
                                      ...formValues["delivery_arrangement"],
                                      value: newValue.value,
                                    },
                                  });
                                }
                              }}
                              renderInput={(params) => (
                                <RedditTextField
                                  className={classes.margin}
                                  {...params}
                                  label="Delivery Arrangement"
                                  id="reddit-input"
                                  size="small"
                                  fullWidth
                                  placeholder="Select"
                                  name="delivery_arrangement"
                                  disabled={
                                    dataId.booking_status !== "6010"
                                      ? true
                                      : false
                                  }
                                />
                              )}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>

                  <hr />

                  {/* label */}
                  <div>
                    <p className="font-weight-boldest">Packages</p>
                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Form.Group as={Row}>
                          <Form.Label column sm={3}>
                            <b>Total Vehicles </b>
                          </Form.Label>
                          <Col sm={6}>
                            <Form.Label column sm={6}>
                              <b>{dataId.total_vehicle}</b>
                            </Form.Label>
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                          <Form.Label column sm={3}>
                            <b>Net Weight </b>
                          </Form.Label>
                          <Col sm={6}>
                            <Form.Label column sm={6}>
                              <b>{dataId.total_netweight}</b>
                            </Form.Label>
                          </Col>
                        </Form.Group>
                        <RedditTextField
                          label="Remarks"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          multiline
                          rows="4"
                          name="remarks"
                          value={formValues.remarks.value}
                          inputProps={{ maxLength: 150 }}
                          onChange={handleChange}
                        />
                      </Col>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Form.Group as={Row}>
                          <Form.Label column sm={3}>
                            <b>Volume </b>
                          </Form.Label>
                          <Col sm={6}>
                            {" "}
                            <Form.Label column sm={6}>
                              <b>{dataId.total_volume}</b>
                            </Form.Label>
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                          <Form.Label column sm={3}>
                            <b>Gross Weight </b>
                          </Form.Label>
                          <Col sm={6}>
                            <Form.Label column sm={6}>
                              <b>{dataId.total_grossweight}</b>
                            </Form.Label>
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                  {/* handleSave */}
                  {dataId.booking_status === "6010" && (
                    <Row className="mt-6 justify-content-end">
                      <Button variant="primary" onClick={handleSave}>
                        Save
                      </Button>
                    </Row>
                  )}

                  <hr />
                  <div className="mb-3">
                    <p className="font-weight-boldest">Parties</p>
                    {/* table */}
                    <BootstrapTable
                      remote
                      wrapperClasses="table-responsive"
                      classes="table table-head-custom table-vertical-center overflow-hidden"
                      bootstrap4
                      keyField="no"
                      data={tableDataParty}
                      columns={columnsParty}
                      pagination={paginationFactory(optionsParty)}
                      onTableChange={handleTableChangeParty}
                      hover
                    ></BootstrapTable>
                    {dataId.booking_status === "6010" && (
                      <Row className="mt-6 justify-content-end">
                        <Button
                          variant="outline-primary"
                          onClick={(e) => setShowParty(true)}
                        >
                          Add Parties
                        </Button>
                      </Row>
                    )}
                  </div>
                  <hr />
                  <div className="mb-3">
                    <p className="font-weight-boldest">Vehicle</p>
                    <div className="d-flex justify-content-end">
                      <div className="p-2 mt-3">Search By</div>
                      <div className="p-2" style={{ width: "180px" }}>
                        {" "}
                        <Select
                          options={vehiclesOptions}
                          value={getValueOptions(
                            vehiclesFilter,
                            vehiclesOptions
                          )}
                          placeholder="Select"
                          onChange={handleChangeVehicles}
                          required
                        />
                      </div>
                      <div className="p-2">
                        <Form.Control
                          type="text"
                          placeholder=""
                          onChange={(e) =>
                            setVehiclesFilterValue(e.target.value)
                          }
                          value={vehiclesFilterValue}
                        />
                      </div>
                      <div className="p-2">
                        {" "}
                        <Button variant="primary" onClick={handleSearch}>
                          Search
                        </Button>
                      </div>
                    </div>

                    {/* table */}

                    <BootstrapTable
                      remote
                      wrapperClasses="table-responsive"
                      classes="table table-head-custom table-vertical-center overflow-hidden"
                      bootstrap4
                      keyField="vehicle_id"
                      data={tableDataVehicle}
                      columns={columns}
                      pagination={paginationFactory(options)}
                      onTableChange={handleTableChange}
                      hover
                    ></BootstrapTable>
                    {dataId.booking_status === "6010" && (
                      <Row className="mt-6 justify-content-end">
                        <Button
                          variant="outline-primary mr-3"
                          onClick={(e) => {
                            setFileName("Upload Template File");
                            setFile(null);
                            setSelectedRows([]);
                            setTableData([]);
                            setShowUpload(true);
                          }}
                        >
                          Upload Vehicle
                        </Button>
                        <Button
                          variant="outline-primary"
                          onClick={(e) => {
                            setGetData(true);
                            setShowVehicle(true);
                          }}
                        >
                          Add Vehicle
                        </Button>
                      </Row>
                    )}
                  </div>
                  <hr />

                  <hr />
                  <div className="mb-3">
                    <p className="font-weight-boldest">File Upload Progress</p>
                    <Row>
                      <Col md={4}>
                        <BootstrapTable
                          wrapperClasses="table-responsive"
                          classes="table table-head-custom table-vertical-center overflow-hidden"
                          bootstrap4
                          keyField="no"
                          data={
                            dataId.tableUploadBookings === null
                              ? []
                              : dataId.tableUploadBookings
                          }
                          columns={columnsFile}
                          hover
                        />
                      </Col>
                    </Row>
                  </div>
                </>
              </ThemeProvider>
            </CardBody>
          </Card>

          <ModalCreateVehicle
            isOpen={showVehicle}
            setShow={setShowVehicle}
            setFormValues={setFormVehicle}
            formValues={formVehicle}
            setFields={setFields}
            fields={fields}
            setGetData={setGetData}
            getData={getData}
            selectedRows={selectedVehicle}
            setSelectedRows={setSelectedVehicle}
          />

          <ModalCreateParty
            isOpen={showParty}
            setShow={setShowParty}
            setFormValues={setFormParty}
            formValues={formParty}
            setFields={setFields}
            fields={fields}
            row={row}
            setRow={setRow}
            id={id}
            getParty={getParty}
            setGetParty={setGetParty}
            statusSave={dataId.booking_status === "6010" ? true : false}
          />

          <BookingCancel
            isOpen={showCancel}
            setShow={setShowCancel}
            id={id}
            name={dataId.booking_no}
          />

          <ModalEditVehicle
            isOpen={showVehicleEdit}
            setShow={setShowVehicleEdit}
            row={row}
            setRow={setRow}
            setFormValues={setFormVehicle}
            formValues={formVehicle}
            setGetData={setGetData}
            getData={getData}
            id={id}
          />

          <VehicleUpload
            isOpen={showUpload}
            setShow={setShowUpload}
            fileName={fileName}
            setFileName={setFileName}
            file={file}
            setFile={setFile}
            tableData={tableData}
            setTableData={setTableData}
            id={id}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
          />
          <VehicleUploadView
            isOpen={showUploadView}
            setShow={setShowUploadView}
            setRowUpload={setRowUpload}
            rowUpload={rowUpload}
            rowUploadStatus={rowUploadStatus}
            setRowUploadStatus={setRowUploadStatus}
          />

          <ModalPartyRadio
            isOpen={showShipper}
            setShow={setShowShipper}
            setFormValues={setFormValues}
            formValues={formValues}
            setFields={setFields}
            fields={fields}
          />
        </>
      )}
    </>
  );
};
